
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div id="blank">
    Hello, Welcome Here
  </div>
</template>

<script>

export default {
  name: 'Blank',
  components: {}
}
</script>
